import { atom } from 'jotai';

import type { PersonFilters } from '../../types/person';

export const personFiltersAtom = atom<PersonFilters>({
  name: '',
  email: '',
  cpf: '',
  companyId: null,
  status: 'all',
  page: 1,
});
